// src/components/inputBehaviors.ts
import * as React from "react";

export function selectAllOnFocus(e: React.FocusEvent<HTMLInputElement>) {
  // Tab focus / programmatic focus
  setTimeout(() => {
    if (document.activeElement === e.currentTarget) {
      e.currentTarget.select();
    }
  }, 0);
}

export function handleMouseDownSelectAll(
  e: React.MouseEvent<HTMLInputElement>
) {
  const input = e.currentTarget;

  // First click into an unfocused field:
  // prevent native caret placement, focus it, then select all
  if (document.activeElement !== input) {
    e.preventDefault();
    input.focus();
    input.select();
  }

  // Already focused:
  // do nothing, so browser places the caret where clicked
}